module.exports = __webpack_public_path__ + "img/cq.1635fef6.svg";